import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, TabPane } from 'reactstrap';
import * as actionTypes from "../../store/Actions/actions";
import * as UTILS from "../../utils/Utils";
import ColorPicker from '../Tool/ColorPicker/ColorPicker';
import Counter from '../Tool/Counter/Counter';

export const TabStyles = () => {
    const { navigationStyle, hamburgerColor } = useSelector(state => state.present);

    const dispatch = useDispatch();


    const resetColor = () => {
        dispatch(actionTypes.nav_class("default"))
        let elementsFont = { ...navigationStyle };
        elementsFont["currentPageBgColor"] = null;
        elementsFont["navigationBgColor"] = null;
        elementsFont["pageMenuBgColor"] = null;
        elementsFont["textActiveColor"] = null;
        elementsFont["textColor"] = null;
        elementsFont["textHoverColor"] = null;
        dispatch(actionTypes.navigation_style(elementsFont))
    };

    const handleNavigationStyle = (property, value) => {
        const navigation_style = navigationStyle ? navigationStyle : {};
        navigation_style[property] = value;
        dispatch(actionTypes.navigation_style(navigation_style))
    };

    const spaceCounterChange = (e, property) => {
        const selectedValue =
            e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
                ? e.target.value.replace(/\b0+/g, "")
                : "0";
        let elementsFont = { ...navigationStyle };
        elementsFont[property] = selectedValue * 1;
        dispatch(actionTypes.navigation_style(elementsFont))
    };

    const spaceCounterPlus = (value, property) => {
        const selectedValue = value;
        let elementsFont = { ...navigationStyle };
        elementsFont[property] = selectedValue + 1;
        dispatch(actionTypes.navigation_style(elementsFont));
    };

    const spaceCounterMinus = (value, property) => {
        const selectedValue = value;
        let elementsFont = { ...navigationStyle };
        elementsFont[property] = selectedValue - 1;
        dispatch(actionTypes.navigation_style(elementsFont));
    };

    const underlineStyle = (value, property) => {
        let elementsFont = { ...navigationStyle };
        elementsFont[property] = value;
        dispatch(actionTypes.navigation_style(elementsFont));
    };

    return (
        <TabPane tabId="3">
            <div
                className="padding-section"
                style={{ marginTop: "10px", marginBottom: "20px" }}
            >
                <div className="heading">Font Options</div>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    flexWrap: "wrap",
                    justifyContent: "center",
                }}
            >
                <Col sm="4" className="selectFontWrapperParent">
                    <label>Font Family</label>
                    <div className="form-group">
                        <div className="selectFontWrapper">
                            <select
                                className="selectFontFamily"
                                type="text"
                                placeholder="Select Font Family"
                                value={
                                    navigationStyle &&
                                        navigationStyle.textFontFamily
                                        ? navigationStyle.textFontFamily
                                        : "Montserrat"
                                }
                                onChange={(e) => {
                                    let textFontFamily = e.target.value;
                                    handleNavigationStyle(
                                        "textFontFamily",
                                        textFontFamily
                                    );
                                }}
                            >
                                {UTILS.googleFonts.map((font, index) => (
                                    <option key={index} value={font.format}>
                                        {font.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </Col>
                <Col sm="3" className="selectFontWrapperParent">
                    <Counter
                        label="Font Size"
                        minusClick={() => {
                            spaceCounterMinus(
                                navigationStyle &&
                                    navigationStyle.textFontSize
                                    ? navigationStyle.textFontSize
                                    : 14,
                                "textFontSize"
                            );
                        }}
                        plusClick={() => {
                            spaceCounterPlus(
                                navigationStyle &&
                                    navigationStyle.textFontSize
                                    ? navigationStyle.textFontSize
                                    : 14,
                                "textFontSize"
                            );
                        }}
                        valueContent={
                            navigationStyle &&
                                navigationStyle.textFontSize
                                ? navigationStyle.textFontSize
                                : 14
                        }
                        onChange={(e) => {
                            spaceCounterChange(e, "textFontSize");
                        }}
                    />
                </Col>
                <Col sm="4">
                    <label style={{ display: 'block' }}>Font Decorators</label>
                    <Button
                        className="boxShadowOnHover"
                        style={{
                            marginRight: "2px",
                            backgroundColor:
                                navigationStyle &&
                                    navigationStyle.textUnderlined
                                    ? "#6c757d"
                                    : "#0c3254",
                        }}
                        onClick={() => {
                            underlineStyle(
                                navigationStyle &&
                                    navigationStyle.textUnderlined
                                    ? !navigationStyle.textUnderlined
                                    : true,
                                "textUnderlined"
                            );
                        }}
                    >
                        <i className="fa fa-underline" aria-hidden="true"></i>
                    </Button>
                    <Button
                        className="boxShadowOnHover"
                        style={{
                            backgroundColor:
                                navigationStyle &&
                                    navigationStyle.textItalic
                                    ? "#6c757d"
                                    : "#0c3254",
                        }}
                        onClick={() => {
                            underlineStyle(
                                navigationStyle &&
                                    navigationStyle.textItalic
                                    ? !navigationStyle.textItalic
                                    : true,
                                "textItalic"
                            );
                        }}
                    >
                        <i className="fa fa-italic" aria-hidden="true"></i>
                    </Button>
                </Col>
            </div>
            <div
                className="padding-section"
                style={{ marginBottom: "20px", marginTop: "20px" }}
            >
                <div className="heading">Navigation Background Color</div>
            </div>

            <div
                className="modalContentWrapper"
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    flexWrap: "wrap",
                }}
            >
                <div className="col-sm-6 navColorOptions">
                    <ColorPicker
                        btnLabel="Header Background Color"
                        colorValue={
                            navigationStyle &&
                                navigationStyle.navigationBgColor
                                ? navigationStyle.navigationBgColor
                                : {
                                    r: 252,
                                    g: 252,
                                    b: 252,
                                    a: 1,
                                }
                        }
                        colorDefaultValue={
                            navigationStyle &&
                                navigationStyle.navigationBgColor
                                ? navigationStyle.navigationBgColor
                                : {
                                    r: 252,
                                    g: 252,
                                    b: 252,
                                    a: 1,
                                }
                        }
                        getColor={(e) => {
                            handleNavigationStyle("navigationBgColor", e.rgb);
                        }}
                    />
                </div>
                <div className="col-sm-6 navColorOptions">
                    <ColorPicker
                        btnLabel="Page Navigation Background Color"
                        colorValue={
                            navigationStyle &&
                                navigationStyle.pageMenuBgColor
                                ? navigationStyle.pageMenuBgColor
                                : {
                                    r: 38,
                                    g: 169,
                                    b: 225,
                                    a: 1,
                                }
                        }
                        colorDefaultValue={
                            navigationStyle &&
                                navigationStyle.pageMenuBgColor
                                ? navigationStyle.pageMenuBgColor
                                : {
                                    r: 38,
                                    g: 169,
                                    b: 225,
                                    a: 1,
                                }
                        }
                        getColor={(e) => {
                            handleNavigationStyle("pageMenuBgColor", e.rgb);
                        }}
                    />
                </div>
                <div className="col-sm-6 navColorOptions">
                    <ColorPicker
                        btnLabel="Current Page Background Color"
                        colorValue={
                            navigationStyle &&
                                navigationStyle.currentPageBgColor
                                ? navigationStyle.currentPageBgColor
                                : {
                                    r: 38,
                                    g: 169,
                                    b: 225,
                                    a: 1,
                                }
                        }
                        colorDefaultValue={
                            navigationStyle &&
                                navigationStyle.currentPageBgColor
                                ? navigationStyle.currentPageBgColor
                                : {
                                    r: 38,
                                    g: 169,
                                    b: 225,
                                    a: 1,
                                }
                        }
                        getColor={(e) => {
                            handleNavigationStyle("currentPageBgColor", e.rgb);
                        }}
                    />
                </div>
            </div>

            <div
                className="padding-section"
                style={{ marginTop: "20px", marginBottom: "20px" }}
            >
                <div className="heading">Navigation Text Color</div>
            </div>
            <div
                className="modalContentWrapper"
                style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    flexWrap: "wrap",
                }}
            >
                {" "}
                <div className="col-sm-6 navColorOptions top-picker">
                    <ColorPicker
                        btnLabel="Text Color"
                        colorValue={
                            navigationStyle &&
                                navigationStyle.textColor
                                ? navigationStyle.textColor
                                : {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                }
                        }
                        colorDefaultValue={
                            navigationStyle &&
                                navigationStyle.textColor
                                ? navigationStyle.textColor
                                : {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                }
                        }
                        getColor={(e) => {
                            handleNavigationStyle("textColor", e.rgb);
                        }}
                    />
                </div>
                <div className="col-sm-6 navColorOptions top-picker">
                    <ColorPicker
                        btnLabel="Text Hover Color"
                        colorValue={
                            navigationStyle &&
                                navigationStyle.textHoverColor
                                ? navigationStyle.textHoverColor
                                : {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                }
                        }
                        colorDefaultValue={
                            navigationStyle &&
                                navigationStyle.textHoverColor
                                ? navigationStyle.textHoverColor
                                : {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                }
                        }
                        getColor={(e) => {
                            handleNavigationStyle("textHoverColor", e.rgb);
                        }}
                    />
                </div>
                <div className="col-sm-6 navColorOptions top-picker">
                    <ColorPicker
                        btnLabel="Current Page Text Color"
                        colorValue={
                            navigationStyle &&
                                navigationStyle.textActiveColor
                                ? navigationStyle.textActiveColor
                                : {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                }
                        }
                        colorDefaultValue={
                            navigationStyle &&
                                navigationStyle.textActiveColor
                                ? navigationStyle.textActiveColor
                                : {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                }
                        }
                        getColor={(e) => {
                            handleNavigationStyle("textActiveColor", e.rgb);
                        }}
                    />
                </div>
            </div>

            <div
                className="padding-section"
                style={{ marginTop: "20px", marginBottom: "20px" }}
            >
                <div className="heading">Hamburger Menu</div>
            </div>
            <div className="modalContentWrapper">
                <div className="col-sm-6">
                    <ColorPicker
                        btnLabel="Hamburger Menu Color"
                        colorValue={hamburgerColor}
                        colorDefaultValue={{
                            r: 0,
                            g: 0,
                            b: 0,
                            a: 1,
                        }}
                        getColor={(e) => {
                            dispatch(actionTypes.hamburger_color(e.rgb))
                        }}
                    />
                </div>
            </div>
        </TabPane>
    )
}
